export default "__VITE_ASSET__D3n8DVS7__"